import * as React from 'react'
import { useCallback } from 'react'
import type { JSX } from 'react'

import clsx from 'clsx'

import { Button, PlusIcon, Tooltip, VisuallyHidden } from '@buffer-mono/popcorn'
import type { ButtonProps } from '@buffer-mono/popcorn'

import { useCalendarContext } from './context'

import styles from './AddButton.module.css'

interface AddButtonProps extends Omit<
  ButtonProps,
  'onClick' | 'tabIndex' | 'children'
> {
  labelDate: string
  fullWidth?: boolean
  timestamp: number
}

export const AddButton = React.memo(
  ({
    labelDate,
    fullWidth = false,
    timestamp,
    className,
    ...props
  }: AddButtonProps): JSX.Element => {
    const {
      addItemProps: { onClick, ...attributes },
    } = useCalendarContext()

    const handleClick = useCallback((): void => {
      onClick(timestamp)
    }, [onClick, timestamp])

    return (
      <Tooltip content="Add a post">
        <Button
          {...attributes}
          variant="secondary"
          className={clsx(
            styles.addUpdateButton,
            {
              [styles.fullWidth]: fullWidth,
            },
            className,
          )}
          tabIndex={-1}
          onClick={handleClick}
          {...props}
        >
          <PlusIcon size={fullWidth ? 'small' : 'medium'} />
          <VisuallyHidden>Schedule post for {labelDate}</VisuallyHidden>
        </Button>
      </Tooltip>
    )
  },
)

AddButton.displayName = 'AddButton'
